import script from "./ExplainTour.vue?vue&type=script&setup=true&lang=js"
export * from "./ExplainTour.vue?vue&type=script&setup=true&lang=js"

import "./ExplainTour.vue?vue&type=style&index=0&id=855ec06a&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-855ec06a"]])

export default __exports__